import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import DatepickerField from 'components/fields/DatepickerField';
import FormError from 'components/common/FormError';

import {
  createDiagnosis,
  updateDiagnosis,
} from 'redux/modules/diagnoses';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import dateFormat from 'config/dateFormat';

import objectDiff from 'utils/objectDiff';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  if (props.ID) {
    if (props.pristine) {
      throw new SubmissionError({
        _error: 'Nothing to submit',
      });
    }
    const diffValues = objectDiff(values, props.initialValues);
    return new Promise((resolve, reject) => {
      dispatch(updateDiagnosis({
        values: {
          ID: props.ID,
          ...diffValues,
          ...diffValues['Expire At'] === '' ? {
            'Expire At': null,
          } : {},
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        if (err.error) {
          throw new SubmissionError({ _error: err.error });
        }
        throw new SubmissionError(err);
      });
  }

  return new Promise((resolve, reject) => {
    dispatch(createDiagnosis({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const DiagnosisCreateEditForm = ({
  handleSubmit,
  className,
  error,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={4}
      >
        <Field
          id="DX Code"
          name="DX Code"
          label="DX Code"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={8}
      >
        <Field
          id="Expire At"
          name="Expire At"
          label="Expires At"
          component={DatepickerField}
          validate={[validate.date]}
          normalize={normalize.date}
          fullWidth
          minDate="01/01/1900"
          maxDate="01/01/2050"
          dateFormat={dateFormat}
          placeholder="mm/dd/yyyy"
          endIcon="start"
          errorPlacement="bottom"
          datepickerPlacement="bottom-right"
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Long Description"
          name="Long Description"
          label="Long Description"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Medium Description"
          name="Medium Description"
          label="Medium Description"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Short Description"
          name="Short Description"
          label="Short Description"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

DiagnosisCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

DiagnosisCreateEditForm.defaultProps = {
  className: '',
  error: null,
};

export default reduxForm({
  form: 'diagnosisCreate',
  onSubmit,
})(withStyles(styles)(DiagnosisCreateEditForm));



// WEBPACK FOOTER //
// ./src/components/settings/DiagnosisCreateEditDialog/DiagnosisCreateEditForm.js